import { render, staticRenderFns } from "./MyAccountAssetsApproved.vue?vue&type=template&id=19539efe"
import script from "./MyAccountAssetsApproved.vue?vue&type=script&lang=js"
export * from "./MyAccountAssetsApproved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports